function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ii_18590_834)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 2.0658,
  y: 1.8125,
  width: 27.875,
  height: 27.875,
  rx: 3.6,
  fill: "url(#paint0_linear_18590_834)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 2.0658,
  y: 1.8125,
  width: 27.875,
  height: 27.875,
  rx: 3.6,
  fill: "url(#paint1_radial_18590_834)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_18590_834)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.2533 4.3125V27.1875",
  stroke: "url(#paint2_linear_18590_834)",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_18590_834)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.52966 3.625H27.3109",
  stroke: "url(#paint3_linear_18590_834)",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_f_18590_834)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.8675 7.25001C22.7319 7.2519 25.8642 10.609 25.8642 14.75C25.8642 18.8921 22.7302 22.25 18.8642 22.25H12.1142C11.9762 22.25 11.8642 22.3619 11.8642 22.5V24.9101C11.8642 25.5927 11.0265 25.9204 10.5633 25.419L6.33434 20.841C6.06889 20.5536 6.06889 20.1105 6.33434 19.8232L10.5633 15.2452C11.0265 14.7438 11.8642 15.0715 11.8642 15.7541V18C11.8642 18.1381 11.9762 18.25 12.1142 18.25H18.8642C20.2656 18.25 21.8642 16.9474 21.8642 14.75C21.8642 12.5526 20.2656 11.25 18.8642 11.25H12.8642C12.3119 11.25 11.8642 10.8023 11.8642 10.25V8.25C11.8642 7.69772 12.3119 7.25 12.8642 7.25H18.8642L18.8675 7.25001Z",
  fill: "#579FFF"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_ii_18590_834)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.8675 7.25001C22.7319 7.2519 25.8642 10.609 25.8642 14.75C25.8642 18.8921 22.7302 22.25 18.8642 22.25H12.1142C11.9762 22.25 11.8642 22.3619 11.8642 22.5V24.9101C11.8642 25.5927 11.0265 25.9204 10.5633 25.419L6.33434 20.841C6.06889 20.5536 6.06889 20.1105 6.33434 19.8232L10.5633 15.2452C11.0265 14.7438 11.8642 15.0715 11.8642 15.7541V18C11.8642 18.1381 11.9762 18.25 12.1142 18.25H18.8642C20.2656 18.25 21.8642 16.9474 21.8642 14.75C21.8642 12.5526 20.2656 11.25 18.8642 11.25H12.8642C12.3119 11.25 11.8642 10.8023 11.8642 10.25V8.25C11.8642 7.69772 12.3119 7.25 12.8642 7.25H18.8642L18.8675 7.25001Z",
  fill: "#FCF2FF"
}));

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ii_18590_834",
  x: 2.0658,
  y: 0.8125,
  width: 28.875,
  height: 28.875,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: -1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.188235 0 0 0 0 0.470588 0 0 0 0 0.843137 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18590_834"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.27451 0 0 0 0 0.34902 0 0 0 0 0.8 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18590_834",
  result: "effect2_innerShadow_18590_834"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_18590_834",
  x: 25.5033,
  y: 1.5625,
  width: 5.5,
  height: 28.375,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "effect1_foregroundBlur_18590_834"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_18590_834",
  x: 2.77966,
  y: 0.875,
  width: 27.2812,
  height: 5.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "effect1_foregroundBlur_18590_834"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_f_18590_834",
  x: 5.13525,
  y: 6.25,
  width: 21.7289,
  height: 20.4116,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_18590_834"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_ii_18590_834",
  x: 5.53525,
  y: 6.85,
  width: 20.7289,
  height: 19.4116,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.6,
  dy: 0.6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.866667 0 0 0 0 0.819608 0 0 0 0 0.941176 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18590_834"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.4,
  dy: -0.4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.988235 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18590_834",
  result: "effect2_innerShadow_18590_834"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_18590_834",
  x1: 16.0033,
  y1: 5.38701,
  x2: 16.0033,
  y2: 38.6397,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5CB7FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4878DD"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_18590_834",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(27.722 3.90625) rotate(136.771) scale(2.14444 2.50466)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7BD7FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7BD7FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_18590_834",
  x1: 28.7533,
  y1: 4.3125,
  x2: 28.7533,
  y2: 27.1875,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7FD9FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#639DF4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_18590_834",
  x1: 28.4672,
  y1: 3.87502,
  x2: 2.93591,
  y2: 3.87502,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7DD8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5DB6FF"
})));

function SvgRightArrowCurvingLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowCurvingLeft);
export default __webpack_public_path__ + "static/media/right-arrow-curving-left.622eabce.svg";
export { ForwardRef as ReactComponent };